import { container } from 'op/container';
import { compose, withHandlers, withState, withProps, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import { withAxios } from 'op/components/auth';
import { withLanguageID } from 'op/components/locale';
import { withErrorHandling } from 'op/components/error';
import { withOnlineStatus } from 'op/components/offline';


export const withFormItems = compose(
    withAxios,
    withLanguageID,
    withErrorHandling,
    withOnlineStatus,
    connect((state) => ({
        items: state.forms.loaded || [],
    }), (dispatch) => ({
        setItems: (items) =>
            dispatch(container.resolve('actions').set_loaded_forms_items(items)),
    })),
    connect(({ auth }) => ({
        user: auth.user,
    })),
    withProps(({ items }) => ({
        ready: items.length !== 0
    })),
    withState('loading', 'setLoading', ({ ready }) => !!ready ? 'partial' : 'full'),
    withHandlers({
        fetchItems: ({ axios, user, language, throwError, setItems, setLoading, online }) => async () => {
            try {
                const { data } = await axios.get('/api/Forms/getAllItems', { "languageID": language })
                setItems(data);
                setLoading(false);
            } catch (e) {
                console.log(e);
                throwError({
                    message: 'Unable to Fetch Forms Items',
                    details: ` 
                        ${e.message}; 
                        ${e.stack} 
                      `,
                });
            }
        }
    }),
    lifecycle({
        componentDidMount() {
            if (this.props.online) {
                this.props.fetchItems();
            } else this.props.setLoading(false);
        }
    }),
);

export const withSearchFiltering = compose(
    withState('search', 'setSearch', ''),
    withProps(({ items, search }) => ({
        items: items
            .filter(item =>
                Object.values(item).some(value =>
                    new RegExp(search, 'i').test(value)
                )
            ),
    })
    ),
)

export default {
    withFormItems,
    withSearchFiltering,
}
